import { fieldMasks, fieldMask, maskLengths, changeFieldType } from '../formFieldOptions';
import FieldOptionsEditor from './FieldOptionsEditor';
import Attention from '../../ReusableComponents/Attention';
import PortalButton from './PortalButton';
import React from 'react';
import PortalFieldHelp from './PortalFieldHelp';
import { formFieldDescriptions } from './registrationFieldDescriptions';
import { MdArrowUpward, MdArrowDownward, MdDelete } from 'react-icons/md';
export default function FormFieldEditor({ field, index, fields, onChange, onMove, onRemove, onAddress, onDocument }) {
  const set = (key, value) =>
    onChange({
      ...field,
      [key]: value,
    });
  return (
    <article className="portal-field-editor">
      <div className="portal-admin-row">
        <h3>
          {index + 1}. {field.label || 'Novo campo'}
        </h3>
        <div className="portal-admin-actions actions-group">
          <PortalButton
            type="button"
            className="btn btn-sm btn-primary"
            title="Mover para cima"
            disabled={index === 0}
            onClick={() => onMove(-1)}
          >
            <MdArrowUpward />
          </PortalButton>
          <PortalButton
            type="button"
            className="btn btn-sm btn-primary"
            title="Mover para baixo"
            disabled={index === fields.length - 1}
            onClick={() => onMove(1)}
          >
            <MdArrowDownward />
          </PortalButton>
          <PortalButton
            type="button"
            className="btn btn-sm btn-danger"
            title="Remover campo"
            disabled={field.locked}
            onClick={onRemove}
          >
            <MdDelete />
          </PortalButton>
        </div>
      </div>
      <div className="portal-admin-grid">
        <label className="form-label">
          <span className="portal-field-label">
            Identificador
            <PortalFieldHelp label="Identificador">{formFieldDescriptions.id}</PortalFieldHelp>
            <Attention />
          </span>
          <input
            className="form-control"
            value={field.id}
            pattern="[a-z][a-z0-9_]{0,49}"
            required
            disabled={field.locked}
            onChange={(e) => set('id', e.target.value)}
          />
        </label>
        <label className="form-label">
          <span className="portal-field-label">
            Nome do campo
            <PortalFieldHelp label="Nome do campo">{formFieldDescriptions.label}</PortalFieldHelp>
            <Attention />
          </span>
          <input
            className="form-control"
            required
            maxLength={255}
            value={field.label}
            onChange={(e) => set('label', e.target.value)}
          />
        </label>
        <label className="form-label">
          <span className="portal-field-label">
            Tipo
            <PortalFieldHelp label="Tipo">{formFieldDescriptions.type}</PortalFieldHelp>
            <Attention />
          </span>
          <select
            className="form-control form-select"
            value={field.type}
            disabled={field.locked}
            onChange={(e) => {
              if (e.target.value === 'address') onAddress();
              else if (e.target.value === 'file' && onDocument) onDocument();
              else onChange(changeFieldType(field, e.target.value));
            }}
            required
          >
            {onAddress && <option value="address">Endereço completo — incluir todos os campos</option>}
            {[
              ['text', 'Texto'],
              ['textarea', 'Texto longo'],
              ['email', 'E-mail'],
              ['tel', 'Telefone'],
              ['number', 'Número'],
              ['date', 'Data'],
              ['select', 'Lista'],
              ['radio', 'Escolha única'],
              ['checkbox', 'Confirmação'],
              ['file', 'Arquivo'],
            ].map(([v, t]) => (
              <option key={v} value={v}>
                {t}
              </option>
            ))}
          </select>
        </label>
        <label className="form-label">
          <span className="portal-field-label">
            Descrição
            <PortalFieldHelp label="Descrição">{formFieldDescriptions.description}</PortalFieldHelp>
            <small className="text-muted">(opcional)</small>
          </span>
          <input
            className="form-control"
            value={field.description || ''}
            onChange={(e) => set('description', e.target.value)}
          />
        </label>
      </div>
      <label className="portal-check portal-field-required">
        <input
          type="checkbox"
          checked={field.required}
          disabled={field.locked}
          onChange={(e) => set('required', e.target.checked)}
        />{' '}
        Obrigatório
        <PortalFieldHelp label="Obrigatório">{formFieldDescriptions.required}</PortalFieldHelp>
      </label>
      {['text', 'tel'].includes(field.type) && (
        <label className="form-label">
          <span className="portal-field-label">
            Máscara<PortalFieldHelp label="Máscara">{formFieldDescriptions.mask}</PortalFieldHelp>
          </span>
          <select
            className="form-control form-select"
            value={fieldMask(field)}
            onChange={(event) =>
              onChange({
                ...field,
                mask: event.target.value,
                ...(maskLengths[event.target.value]
                  ? { max_length: maskLengths[event.target.value] }
                  : {}),
              })
            }
          >
            {fieldMasks.map(([value, label]) => (
              <option key={value} value={value}>
                {label}
              </option>
            ))}
          </select>
          <small className="form-text">
            A sugestão considera o identificador, o nome e o tipo do campo. Você pode alterá-la.
          </small>
        </label>
      )}
      {field.type === 'file' && (
        <div className="portal-admin-grid">
          <label className="form-label">
            <span className="portal-field-label">
              Arquivos aceitos
              <PortalFieldHelp label="Arquivos aceitos">
                {formFieldDescriptions.file_types}
              </PortalFieldHelp>
              <Attention />
            </span>
            <select
              className="form-control form-select"
              value={field.file_types || 'image_pdf'}
              required
              onChange={(event) => set('file_types', event.target.value)}
            >
              <option value="image">Somente imagens</option>
              <option value="pdf">Somente PDF</option>
              <option value="image_pdf">Imagens e PDF</option>
            </select>
          </label>
          <label className="form-label">
            <span className="portal-field-label">
              Tamanho máximo (KB)
              <PortalFieldHelp label="Tamanho máximo">
                {formFieldDescriptions.max_kb}
              </PortalFieldHelp>
              <Attention />
            </span>
            <input
              type="number"
              className="form-control"
              min={1}
              max={20480}
              step={1}
              required
              value={field.max_kb ?? 5120}
              onChange={(event) =>
                set('max_kb', event.target.value === '' ? '' : Number(event.target.value))
              }
            />
            <small className="form-text">1.024 KB = 1 MB. Limite de até 20 MB por arquivo.</small>
          </label>
        </div>
      )}
      {['select', 'radio'].includes(field.type) && (
        <FieldOptionsEditor
          options={field.options}
          onChange={(options) => set('options', options)}
        />
      )}
      {['text', 'textarea', 'email', 'tel'].includes(field.type) && (
        <label className="form-label">
          <span className="portal-field-label">
            Limite de caracteres
            <PortalFieldHelp label="Limite de caracteres">
              {formFieldDescriptions.max_length}
            </PortalFieldHelp>
            <small className="text-muted">(opcional)</small>
          </span>
          <input
            className="form-control"
            type="number"
            min={1}
            max={20000}
            value={field.max_length || ''}
            onChange={(e) => set('max_length', e.target.value ? Number(e.target.value) : undefined)}
          />
        </label>
      )}
      {field.type === 'number' && (
        <div className="portal-admin-grid">
          {['min', 'max'].map((key) => (
            <label key={key} className="form-label">
              <span className="portal-field-label">
                {key === 'min' ? 'Mínimo' : 'Máximo'}
                <PortalFieldHelp label={key === 'min' ? 'Mínimo' : 'Máximo'}>
                  {formFieldDescriptions[key]}
                </PortalFieldHelp>
                <small className="text-muted">(opcional)</small>
              </span>
              <input
                className="form-control"
                type="number"
                step="any"
                value={field[key] ?? ''}
                onChange={(e) => set(key, e.target.value ? Number(e.target.value) : undefined)}
              />
            </label>
          ))}
        </div>
      )}
      <label className="form-label">
        <span className="portal-field-label">
          Exibir apenas quando
          <PortalFieldHelp label="Exibir apenas quando">
            {formFieldDescriptions.conditions}
          </PortalFieldHelp>
          <small className="text-muted">(opcional)</small>
        </span>
        <select
          className="form-control form-select"
          disabled={field.locked}
          value={field.conditions?.[0]?.field || ''}
          onChange={(e) =>
            set(
              'conditions',
              e.target.value
                ? [
                    {
                      field: e.target.value,
                      operator: 'equals',
                      value: '',
                    },
                  ]
                : []
            )
          }
        >
          <option value="">Sempre</option>
          {fields
            .filter((f) => f.id !== field.id && f.type !== 'file')
            .map((f) => (
              <option key={f.id} value={f.id}>
                {f.label}
              </option>
            ))}
        </select>
      </label>
      {field.conditions?.[0] && (
        <div className="portal-admin-grid">
          <label className="form-label">
            <span className="portal-field-label">
              Condição
              <PortalFieldHelp label="Condição">{formFieldDescriptions.operator}</PortalFieldHelp>
              <Attention />
            </span>
            <select
              className="form-control form-select"
              value={field.conditions[0].operator}
              onChange={(e) =>
                set('conditions', [
                  {
                    ...field.conditions[0],
                    operator: e.target.value,
                  },
                ])
              }
              required
            >
              <option value="equals">Igual a</option>
              <option value="not_equals">Diferente de</option>
            </select>
          </label>
          <label className="form-label">
            <span className="portal-field-label">
              Valor
              <PortalFieldHelp label="Valor">{formFieldDescriptions.value}</PortalFieldHelp>
              <small className="text-muted">(opcional)</small>
            </span>
            <input
              className="form-control"
              value={String(field.conditions[0].value ?? '')}
              onChange={(e) => {
                const type = fields.find((f) => f.id === field.conditions[0].field)?.type;
                set('conditions', [
                  {
                    ...field.conditions[0],
                    value:
                      type === 'number'
                        ? Number(e.target.value)
                        : type === 'checkbox'
                        ? e.target.value === 'true'
                        : e.target.value,
                  },
                ]);
              }}
            />
          </label>
        </div>
      )}
    </article>
  );
}
